import { Typography, Grid, Box, useMediaQuery, Button } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import KenButton from "../../../../GlobalComponents/KenButton";
import { useStyles } from "../../style";
import flamelogo1 from "../../../../Assets/flamelogo1.svg"
import AlumniIdBg from "../../../../Assets/AlumniIdCardBg.jpg";
import { AuthContext } from "../../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../../interfaces/Contexts";
import idcard from "../../../../Assets/idcard.png";
import defaultProfile from "../../../../Assets/DefaultProfile.png";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: { xs: '90%', sm: '780px' },
  maxWidth: { xs: '100%', sm: '780px' },
  bgcolor: "background.paper",
  border: "2px solid white",
  boxShadow: 24,
  borderRadius: 2,
  p: { xs: 1.5, sm: 2 },
  overflowY: "auto",
  maxHeight: { xs: '90vh', sm: '80vh' }
};


const IdCard = (props: any) => {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:1025px)');
  return (
    <div>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>
              ID Card
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "end", cursor: "pointer" }}
          >
            <CloseIcon onClick={props.handleClose} sx={{ fontSize: "15px" }} />
          </Grid>
        </Grid>
        <hr style={{ border: "1px solid #E6E6E8" }} />

        {/* Display PDF Preview */}
        <Box
          sx={{
            width: { xs: '98vw', sm: 420, md: 600 },
            maxWidth: { xs: 340, sm: 420, md: 600 },
            aspectRatio: { xs: '1.6/1', sm: '2.2/1' },
            backgroundImage: `url(${AlumniIdBg})`,
            backgroundSize: 'cover',
            border: '2px solid #174A7C',
            borderRadius: { xs: '12px', sm: '24px' },
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden',
            minHeight: { xs: 140, sm: 220, md: 260 },
            maxHeight: { xs: 180, sm: 320, md: 340 },
            position: 'relative',
          }}
        >
          {/* Left Section */}
          <Box sx={{
            flex: 2,
            padding: { xs: "10px 0px 5px 12px", sm: "15px 0px 5px 12px" },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            background: 'rgba(255, 255, 255, 0.3)'
          }}>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 0.5, sm: 1 } }}>
                <img src={flamelogo1 ? flamelogo1 : defaultProfile} alt="Flame Logo"
                  style={{
                    height: isMobile ? 20 : 45,
                    marginRight: 6
                  }}
                />
              </Box>
              <Box sx={{ borderTop: '2px solid #174A7C', my: 1 }} />
              <Typography sx={{ fontWeight: 500, fontSize: isMobile ? 12 : 20, color: '#222' }}>{props?.IdCardData?.accountDetails?.FirstName} {props?.IdCardData?.accountDetails?.LastName}</Typography>
              <Box sx={{ borderTop: '2px solid #174A7C', my: 1 }} />
              <Typography sx={{ fontWeight: 500, fontSize: isMobile ? 10 : 16, color: '#222' }}>CLASS OF {props?.IdCardData?.alumniDetails?.Year_of_Graduation__c ? props?.IdCardData?.alumniDetails?.Year_of_Graduation__c : ''}</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: isMobile ? 10 : 16, color: '#222' }}>ID : {props?.IdCardData?.alumniDetails?.Contact__r?.CVUE_Student_Number__c ? props?.IdCardData?.alumniDetails?.Contact__r?.CVUE_Student_Number__c : props?.IdCardData?.alumniDetails?.Contact__r?.CVUE_Student_Number__c}</Typography>
            </Box>
            <Box>
              <Box sx={{ borderTop: '2px solid #174A7C', my: 1 }} />
              <Typography sx={{ fontSize: isMobile ? 8 : 14, color: '#222', textAlign: 'right', fontWeight: 500, paddingRight: "20px", fontStyle: "italic" }}>
                FLAME University Alumni Association<br />
                http://alumni.flame.edu.in
              </Typography>
            </Box>
          </Box>

          {/* Right Section */}
          <Box sx={{
            flex: 1,
            marginRight: isMobile ? "25px" : "40px",
            background: '#174A7C',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative'
          }}>
            <img
              src={props?.IdCardData?.accountDetails?.Profile_Picture_URL__c}
              alt="Profile"
              style={{
                width: isMobile ? 80 : 140,
                height: isMobile ? 136 : 136,
                borderRadius: 6,
                marginTop: isMobile ? 4 : 10,
                objectFit: 'cover',
              }}
            />
            <Typography sx={{ fontWeight: 500, fontSize: { xs: 10, sm: 18 }, mt: isMobile ? 1 : 0 }}>
              ALUMNI
            </Typography>
            <img
              src={props?.IdCardData?.alumniDetails?.QR_Code_URL__c}
              alt="QR"
              style={{
                width: isMobile ? 32 : 42,
                height: isMobile ? 32 : 42,
                margin: '4px 0'
              }}
            />
            <img src={idcard} alt="Id Card" style={{ width: isMobile ? 70 : 135, height: isMobile ? 35 : 55, marginLeft: isMobile ? 10 : 14 }} />
          </Box>
        </Box>
        <Box sx={{
          display: "flex",
          justifyContent: 'center',
          alignItems: 'center',
          mt: { xs: 2, sm: 2 },
          width: '100%',
        }}>
          {props?.IdCardData && (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => {
                const link = document.createElement("a");
                link.href = props?.IdCardData?.alumniDetails?.ID_Card_URL__c;
                link.download = "filled_certificate.pdf";
                link.click();
              }}
              fullWidth
              sx={{
                height: { xs: '36px', sm: '40px' },
                fontSize: { xs: '14px !important', sm: '14px', md: '16px' },
                fontWeight: 500,
                borderRadius: '8px',
              }}
            >
              Download
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default IdCard;
